import { useEffect } from "react"
import { Dispatch } from "../stores/reducer"
import { Panes } from "../types"

interface BrowserNavigationHandlerProps {
  dispatch: Dispatch
  focusedPane: Panes
}

export function BrowserNavigationHandler({
  dispatch,
  focusedPane,
}: BrowserNavigationHandlerProps) {
  useEffect(() => {
    setHistoryStateIfMissing(focusedPane)
  }, [focusedPane])

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      const targetPane = event.state?.focusedPane
      if (targetPane && targetPane !== focusedPane) {
        dispatch({ type: "SET_FOCUSED_PANE", payload: targetPane })
      }
    }

    window.addEventListener("popstate", handlePopState)
    return () => window.removeEventListener("popstate", handlePopState)
  }, [dispatch, focusedPane])

  // This component doesn't render anything
  return null
}

export function pushBrowserHistoryState(focusedPane: Panes) {
  window.history.pushState({ focusedPane }, "", window.location.href)
}

function setHistoryStateIfMissing(focusedPane: Panes) {
  if (!window.history.state?.focusedPane) {
    window.history.replaceState({ focusedPane }, "", window.location.href)
  }
}
